"use client";
import {
  Image_default
} from "./chunk-KBWHYFNM.mjs";
import {
  Button_default
} from "./chunk-WBZIOSC6.mjs";
import {
  Icon_default
} from "./chunk-KJNGPZGH.mjs";

// src/components/sections/RTB/RTB.tsx
import { useResponsiveQuery } from "atomic-layout";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var RTB = ({
  title,
  description,
  image,
  features,
  buttons,
  qrCodeLink,
  viewButton = true,
  primaryButton = 1
}) => {
  const isTabletWeb = useResponsiveQuery({ from: "md" });
  const isMobile = useResponsiveQuery({ to: "sm" });
  return /* @__PURE__ */ jsxs("div", { className: "relative lg:h-[880px] md:min-h-[648px]", children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: `px-24 flex gap-24 lg:gap-[40px] items-center md:items-start md:justify-between m-auto lg:pb-[120px] lg:pt-[80px] lg:max-w-[1280px] py-[40px]  md:max-w-[768px] md:flex-row flex-col-reverse`,
        children: [
          /* @__PURE__ */ jsx(
            Image_default,
            {
              src: image.path,
              width: 421,
              height: 540,
              alt: image.alternativeText,
              className: "flex justify-center items-center w-[298px] md:w-[326px] lg:w-[620px] lg:max-w-[421px] h-auto lg:max-h-[540px]"
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "flex items-center md:w-[349px] lg:w-[620px] h-[220px] sm:h-[132px] md:h-[330px] lg:h-[540px]", children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col md:gap-16 lg:gap-24", children: [
            /* @__PURE__ */ jsxs("div", { children: [
              /* @__PURE__ */ jsx("h2", { className: "mb-8 font-display text-[28px] lg:text-[32px] font-bold leading-[36px] lg:leading-[40px]", children: title }),
              /* @__PURE__ */ jsx("p", { className: "font-sharon text-[18px] lg:text-[20px] leading-[26px] lg:leading-5", children: description })
            ] }),
            isTabletWeb && /* @__PURE__ */ jsx("div", { className: "flex z-10 md:flex-col lg:flex-row gap-8 lg:gap-[16px] md:mb-24 w-[232px] lg:w-auto", children: buttons.map((button, index) => /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(Button_default, { ...[button], children: button.children }, index) })) })
          ] }) })
        ]
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "flex absolute top-[260px] sm:top-[220px] md:top-[180px] lg:top-[205px] flex-col gap-24 justify-center items-center py-16 pl-24 w-full h-full", children: [
      /* @__PURE__ */ jsx("div", { className: "flex overflow-x-auto gap-24 xl:justify-center pr-24 w-full", children: features.map(({ title: title2, description: description2, icon }, index) => /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(
        "div",
        {
          className: `flex flex-col md:w-[286px] lg:w-[302px] w-[257px] bg-display-100 border-display-100 rounded-[16px] border-2 md:p-24 p-16`,
          children: [
            /* @__PURE__ */ jsx("div", { className: "flex justify-center items-center mb-16 lg:mb-24 w-48 min-h-[48px] bg-stone-100 rounded-[8px]", children: /* @__PURE__ */ jsx(
              Icon_default,
              {
                name: icon,
                className: "w-24 h-24 text-stone-500 fill-current"
              }
            ) }),
            /* @__PURE__ */ jsx("h3", { className: "font-display text-lg lg:text-xl font-bold leading-[28px] lg:leading-7", children: title2 }),
            /* @__PURE__ */ jsx("p", { className: "md:max-w-[300px] lg:max-w-[330px] font-sharon text-[16px] lg:text-lg tracking-tight leading-[26px]", children: description2 })
          ]
        }
      ) }, index)) }),
      /* @__PURE__ */ jsx("div", { className: "pr-24 w-full", children: isMobile && viewButton && /* @__PURE__ */ jsx(Button_default, { color: "secondary", ...[buttons[primaryButton]], children: buttons[primaryButton].children }) })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "flex md:hidden px-24 mt-[124px] sm:mt-[130px]" })
  ] });
};
var RTB_default = RTB;

export {
  RTB_default
};
